<template>
  <div class="calendar-host">
    <EventEditor
      v-if="editor.open"
      :key="editor.key"
      :draft="editor.draft"
      @saved="saved"
      @close="close(null)"
      @cancel-event="cancelFromEditor"
    />
    <ScopeDialog />
  </div>
</template>

<script setup>
import { useCalendarEditor, touch } from '../store'
import { useEventActions } from '../actions'
import EventEditor from './EventEditor.vue'
import ScopeDialog from './ScopeDialog.vue'

/**
 * Mounted once by the shell (an overlay of the platform): the editor and the
 * «which occurrences?» question, over whatever screen is showing. That is what
 * lets the mail reader open «New meeting» without navigating anywhere.
 */
const { editor, close } = useCalendarEditor()
const { cancelEvent } = useEventActions()

function saved(event) {
  touch()
  close(event)
}

async function cancelFromEditor(event) {
  const draft = editor.draft
  close(null)
  const done = await cancelEvent(event)
  if (!done && draft) {
    // Nothing happened: back to where the person was.
    const { open } = useCalendarEditor()
    open(draft)
  }
}
</script>
